import { Chip, Dialog, DialogContent, DialogContentText, DialogTitle } from '@mui/material';
import { formatCountdown } from './useBookingDeadline';

/** Süre-doldu modalı + üstte kalan-süre çipi — `BookingFlowShell` süre yapılandırması
 *  verildiğinde kullanılır. */
export function DeadlineExpiredDialog({
  open,
  redirectIn,
  resumed,
  copy,
}: {
  open: boolean;
  redirectIn: number;
  resumed: boolean;
  copy?: { resumed: string; fresh: string };
}) {
  const resumedText = copy?.resumed ?? 'Bu rezervasyonun son geçerlilik süresi doldu.';
  const freshText = copy?.fresh ?? 'Arama sonrası tanınan 15 dakikalık süre doldu.';
  return (
    <Dialog open={open}>
      <DialogTitle>İşlem Süreniz Bitmiştir</DialogTitle>
      <DialogContent>
        <DialogContentText>
          {resumed ? resumedText : freshText} {redirectIn} saniye içinde ana sayfaya
          yönlendirileceksiniz.
        </DialogContentText>
      </DialogContent>
    </Dialog>
  );
}

export function DeadlineChip({ remainingMs }: { remainingMs: number }) {
  return (
    <Chip
      size="small"
      color={remainingMs <= 60_000 ? 'error' : 'default'}
      label={`Kalan süre: ${formatCountdown(remainingMs)}`}
    />
  );
}
